import { Card, Col, Row } from "react-bootstrap";
import { useEffect, useState } from "react";
import BASE_URL from "../../../assets/global/url";
import axios from "axios";

const formatCurrency = (value, currencyName) => {
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: currencyName,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(value);
};

const formatNumber = (value) => {
  return new Intl.NumberFormat("en-US").format(value);
};

const GET_FIXED_ASSET_PREVIEW_WIDGET_URL = `${BASE_URL}/fixedasset/v2/getFixedAssetPreviewWidget`;

const FixedAssetPreviewWidget = ({
  fixedAssetId,
  status,
  currencyName,
  totalCost,
  handleOpenJournalModal,
  handleOpenForecastModal,
  monthsToPay,
  refreshTrigger,
}) => {
  const [expensesValue, setExpensesValue] = useState(0);
  const [productCurrentValue, setProductCurrentValue] = useState(0);
  const [paidMonths, setPaidMonths] = useState(0);

  const fetchFixedAssetPreviewWidget = async (fixedAssetId) => {
    axios
      .get(GET_FIXED_ASSET_PREVIEW_WIDGET_URL, {
        params: { id: fixedAssetId },
      })
      .then((res) => {
        setExpensesValue(res.data.expensesValue);
        setProductCurrentValue(res.data.productCurrentValue);
        setPaidMonths(res.data.paidMonths);
      })
      .catch((error) => {
        console.error("[Axios Error - fetchFixedAssetPreviewWidget]", error);
      });
  };

  // Only Fetch the Api if status is Approved and there is fixedAssetId
  useEffect(() => {
    if (status === "Approved" && fixedAssetId) {
      fetchFixedAssetPreviewWidget(fixedAssetId);
    }
  }, [status, fixedAssetId, refreshTrigger]);

  return (
    <Row className="mt-3 mx-auto">
      <Col sm>
        <Card
          className="text-center"
          onClick={handleOpenJournalModal}
          style={{ cursor: "pointer" }}
        >
          <Card.Body>
            <Card.Title>
              <h5>Expenses Value</h5>
              <Card.Text className="text-success amount text-decoration-underline">
                {formatCurrency(expensesValue, currencyName)}
              </Card.Text>
              <Card.Text>
                from {formatCurrency(totalCost, currencyName)}
              </Card.Text>
            </Card.Title>
          </Card.Body>
        </Card>
      </Col>
      <Col sm>
        <Card
          className="text-center"
          onClick={handleOpenForecastModal}
          style={{ cursor: "pointer" }}
        >
          <Card.Body>
            <Card.Title>
              <h5>Product Current Value</h5>
              <Card.Text className="text-success amount text-decoration-underline">
                {formatCurrency(productCurrentValue, currencyName)}
              </Card.Text>
              <Card.Text>
                from {formatCurrency(totalCost, currencyName)}
              </Card.Text>
            </Card.Title>
          </Card.Body>
        </Card>
      </Col>
      <Col sm>
        <Card
          className="text-center"
          onClick={handleOpenForecastModal}
          style={{ cursor: "pointer" }}
        >
          <Card.Body>
            <Card.Title>
              <h5>Months Remaining</h5>
              <Card.Text className="text-success amount text-decoration-underline">
                {formatNumber(paidMonths)}
              </Card.Text>
              <Card.Text>Of {formatNumber(monthsToPay)} months</Card.Text>
            </Card.Title>
          </Card.Body>
        </Card>
      </Col>
    </Row>
  );
};

export { FixedAssetPreviewWidget };
